import React, { useEffect, useState } from "react";
import { getCurrentlyLoggedInUser } from "../../CommonFunctions";
import { LoggedInAccount } from "../../Interfaces/AccountUsers";
import fetchWithAuth from "../../services/fetchWithAuth";
import config from "../../config";
import PopupModel from "../../components/Popup/PopupModel";
import { usePopup } from "../../components/Popup/PopupContext";

const LogoRequestPage = () => {
  const [user, setUser] = useState<LoggedInAccount>();
  const [org_name, set_org_name] = useState("");
  const [file_upload, set_file_upload] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [options, setOptions] = useState({
    need_spangle: false,
    need_print: false,
    need_laser_engraving: false,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { showPopup, hidePopup } = usePopup();

  const submissionSuccessPopup = new PopupModel(
    "Submission Successful!", // header
    (
      <div>
        <strong>The logo request was successfully submitted</strong>
      </div> //body
    ),
    [
      {
        label: "Okay",
        onClick: () => {
          hidePopup();
        },
      },
    ],
    "40vw" //width
  );

  const clearForm = () => {
    set_org_name("");
    set_file_upload(null);
    setOptions({
      need_spangle: false,
      need_print: false,
      need_laser_engraving: false,
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const data = await getCurrentlyLoggedInUser();
      setUser(data);
    };

    document.title = "MamFam Logo Request";
    getUser();
  }, []);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOptions({ ...options, [e.target.name]: e.target.checked });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    setIsLoading(true);
    e.preventDefault();
    if (!file_upload) {
      setError("Please upload a file before submitting.");
      setIsLoading(false);
      return;
    }
    const atLeastOneChecked =
      options.need_spangle ||
      options.need_print ||
      options.need_laser_engraving;
    if (!atLeastOneChecked) {
      setError(
        "Please select at least one option: Spangle, Printed, or Laser Engraved."
      );
      setIsLoading(false);
      return;
    }

    setError(null);

    const formData = new FormData();
    formData.append("org_name", org_name);
    formData.append("file_upload", file_upload);
    formData.append("need_spangle", String(options.need_spangle));
    formData.append("need_print", String(options.need_print));
    formData.append(
      "need_laser_engraving",
      String(options.need_laser_engraving)
    );
    formData.append("user", String(user?.id));
    try {
      const response = await fetchWithAuth(
        `${config.API_BASE_URL}logo_requests/`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.status === 200) {
        showPopup(
          submissionSuccessPopup.header,
          submissionSuccessPopup.body,
          submissionSuccessPopup.buttons,
          submissionSuccessPopup.width
        );
        clearForm();
      } else {
        alert("Failed to properly submit logo request");
        console.log(response);
      }
    } catch {
      alert("Failed to submit Logo Request");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h1>Logo Request</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Organization Name:</label>
          <input
            type="text"
            value={org_name}
            onChange={(e) => set_org_name(e.target.value)}
            required
          />
        </div>
        <div style={{ marginTop: "12px" }}>
          <label>Upload File:</label>
          <br />
          <label
            htmlFor="file-upload"
            style={{
              display: "inline-block",
              padding: "8px 12px",
              backgroundColor: "#007bff",
              color: "#fff",
              cursor: "pointer",
              borderRadius: "4px",
            }}
          >
            Choose File
          </label>
          <input
            id="file-upload"
            type="file"
            style={{ display: "none" }}
            onChange={(e) => set_file_upload(e.target.files?.[0] || null)}
          />
          {file_upload && (
            <span style={{ marginLeft: "10px" }}>{file_upload.name}</span>
          )}
        </div>
        <div style={{ marginTop: "12px" }}>
          <label>
            <input
              type="checkbox"
              name="need_spangle"
              checked={options.need_spangle}
              onChange={handleCheckboxChange}
            />
            Spangle
          </label>
        </div>
        <div>
          <label>
            <input
              type="checkbox"
              name="need_print"
              checked={options.need_print}
              onChange={handleCheckboxChange}
            />
            Printed
          </label>
        </div>
        <div>
          <label>
            <input
              type="checkbox"
              name="need_laser_engraving"
              checked={options.need_laser_engraving}
              onChange={handleCheckboxChange}
            />
            Laser Engraved
          </label>
        </div>
        {error && (
          <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
        )}
        <button
          type="submit"
          style={{ marginTop: "16px" }}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default LogoRequestPage;
